<template>
  <LinkButton
    tag="nuxt-link"
    to="/shop/warenkorb"
    variant="transparent"
    data-tealium-rel="header.button.warenkorb"
    class="cart-indicator"
    active-class="navigation-controls__link--active"
    :aria-label="`Warenkorb, ${cartQuantity === 1 ? '1 Produkt' : `${cartQuantity || 0} Produkte`}`"
  >
    <SvgIcon
      no-icon-class
      class="btn__icon"
      :image="cartIcon"
    />
    <slot />
    <CountBadge
      v-if="cartQuantity"
      :value="cartQuantity"
      class="cart-indicator__count"
    />
  </LinkButton>
</template>

<script setup lang="ts">
import { LinkButton } from '@i22team/td-longtail-vue-components';
import { storeToRefs } from 'pinia';
import cartIcon from '~/assets/images/navigation/basket.svg';
import CountBadge from '~/components/count-badge.vue';
import { useCartStore } from '~/stores/cart';

const { cartQuantity } = storeToRefs(useCartStore());
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.cart-indicator {
  &__count {
    font-size: 12px;
    position: absolute;
    right: -4px;
    top: 15px;
  }
}
</style>
